
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { MangopayCardRegistrationData, UserCardData } from '../models/payment-provider/mangopay.model';
import { MangoError } from '../models/mangoError.model';
import { map, switchMap, tap } from 'rxjs';
import { PaymentProviderType } from '../models';


@Injectable({
  providedIn: 'root',
})
export class MangopayService {
  private http = inject(HttpClient);
  private isBrowser: boolean;

  constructor() {
    const platformId = inject(PLATFORM_ID);

    this.isBrowser = isPlatformBrowser(platformId);
  }

  public createCardRegistration(paymentIntent: MangopayCardRegistrationData, cardData: UserCardData) {
    const BrowserInfo = this.fillBrowserInfo();
    const formData = new URLSearchParams();
    formData.set('data', paymentIntent.PreregistrationData);
    formData.set('accessKeyRef', paymentIntent.AccessKey);
    formData.set('cardNumber', cardData.cardNumber);
    formData.set('cardExpirationDate', cardData.cardExpirationDate);
    formData.set('cardCvx', cardData.cardCvx);

    return this.http.post(
      paymentIntent.CardRegistrationURL,
      formData,
      {
        headers: new HttpHeaders({
          'Content-Type':  'application/x-www-form-urlencoded',
        }),
        responseType: 'text',
      },
    ).pipe(
      // force unknown type in case of mangopay error => we would need to type check before using the value
      tap( (RegistrationData: unknown) => {
        if (typeof RegistrationData === 'string' || RegistrationData instanceof String) {
          const errorIndex = RegistrationData.indexOf('errorCode=');
          if ( errorIndex >= 0 ) {
            const errorCode = RegistrationData.slice(errorIndex + 10) as string;
            throw new HttpErrorResponse({error: new MangoError(parseInt(errorCode, 10) ??  errorCode, 'Card obj error', 'Error')});
          }
        }
      }),
      map( (RegistrationData) => ({[PaymentProviderType.Mangopay]: {
        RegistrationData,
        BrowserInfo,
        Id: paymentIntent.Id,
      }})),
    );
  }

  private fillBrowserInfo() {
    if (!this.isBrowser) {
      return {};
    }
    return {
      AcceptHeader: '', // string, filled later with backend req object
      ColorDepth: window.screen.colorDepth, // int
      JavaEnabled: false, // boolean
      JavascriptEnabled: true , // boolean
      Language: navigator.language, // string
      ScreenHeight: screen.height, // int
      ScreenWidth: screen.width, // int
      TimeZoneOffset: (new Date()).getTimezoneOffset()?.toString(), // string
      UserAgent: navigator.userAgent, // string
    };
  }

}


